import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const FresherJobsGurugram = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Fresher Jobs in Gurugram | Latest Job Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest fresher jobs in Gurugram NCR for graduates and students. Apply for IT, Marketing, Finance, HR, and Sales jobs in top companies hiring freshers in Gurugram."
        />
        <meta
          name="keywords"
          content="fresher jobs in Gurugram, fresher jobs in Gurugram , jobs for freshers in Gurugram, IT fresher jobs Gurugram, marketing fresher jobs Gurugram, graduate jobs Gurugram, entry-level jobs Gurugram"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jobsindelhincr.in/fresher-jobs-in-Gurugram" />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Fresher Jobs in Gurugram – Latest Job Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>fresher jobs in Gurugram</strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a graduate or a student, find your
          first job in Gurugram NCR today and kickstart your career.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Freshers in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Gurugram</li>
          <li>Marketing Jobs in Gurugram</li>
          <li>Finance Jobs in Gurugram</li>
          <li>Sales Jobs in Gurugram</li>
          <li>Full-time Jobs in Gurugram</li>
          <li>Web Development Jobs in Gurugram</li>
          <li>Digital Marketing Jobs in Gurugram</li>
          <li>Telecalling Jobs in Gurugram</li>
          <li>IT Jobs in Gurugram</li>
          <li>Technical Support Jobs in Gurugram</li>
          <li>App Development Jobs in Gurugram</li>
          <li>HR Jobs in Gurugram</li>
          <li>Fresher Jobs in Gurugram</li>
          <li>Frontend Developer Jobs in Gurugram</li>
          <li>Backend Developer Jobs in Gurugram</li>
          <li>Full Stack Developer Jobs in Gurugram</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> – your trusted
          platform to find verified <strong>fresher job openings</strong> in Gurugram.
          No registration required – apply directly to companies hiring today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default FresherJobsGurugram;
